import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInAuthGuard } from './core/guard/logged-in-auth.guard';
import { LoginPageComponent } from './features/auth/authentication/login-page/login-page.component';
import { AuthGuard } from './core/guard/auth.guard';
import { PermissionGuard } from './core/guard/permission.guard';
import { FeatureFlagGuard } from './core/guard/feature-flag.guard';
import { MainPageComponent } from './layout/main-page/main-page.component';
import { ListProduitsComponent } from './features/produits/components/list-produits/list-produits.component';
import { AddProduitsComponent } from './features/produits/components/add-produits/add-produits.component';
import { ListCategoriesComponent } from './features/categories/components/list-categories/list-categories.component';
import { ListTagsComponent } from './features/tags/components/list-tags/list-tags.component';
import { ListBrandsComponent } from './features/brands/components/list-brands/list-brands.component';
import { ListCustomersComponent } from './features/customers/components/list-customers/list-customers.component';
import { AddCustomersComponent } from './features/customers/components/add-customers/add-customers.component';
import { ListCatalogsComponent } from './features/catalogs/components/list-catalogs/list-catalogs.component';
import { AddCatalogsComponent } from './features/catalogs/components/add-catalogs/add-catalogs.component';
import { RecapLocationComponent } from './features/customers/components/recap-location/recap-location.component';
import { ListCompaniesGroupsComponent } from './features/companies-groups/components/list-companies-groups/list-companies-groups.component';
import { AddCompaniesGroupsComponent } from './features/companies-groups/components/add-companies-groups/add-companies-groups.component';
import { ListQuotationsComponent } from './features/quotations/components/list-quotations/list-quotations.component';
import { DetailsQuotesComponent } from './features/quotations/components/details-quotes/details-quotes.component';
import { AddQuotationComponent } from './features/quotations/components/add-quotation/add-quotation.component';
import { ListOrdersComponent } from './features/orders/components/list-orders/list-orders.component';
import { ListImportsComponent } from './features/imports/components/list-imports/list-imports.component';
import { UploadProcessingComponent } from './features/imports/components/upload-processing/upload-processing.component';
import { OrganizeComponent } from './features/organize/components/organize/organize.component';
import { DetailsImportsComponent } from './features/imports/components/details-imports/details-imports.component';
import { ListSegmentsComponent } from './features/segments/components/list-segments/list-segments.component';
import { DetailsCatalogComponent } from './features/catalogs/components/details-catalog/details-catalog.component';
import { DetailsProductComponent } from './features/produits/components/details-product/details-product.component';
import { MainSettingsComponent } from './features/settings/components/main-settings/main-settings.component';
import { UsersComponent } from './features/settings/components/team-management/users/users.component';
import { RolesComponent } from './features/settings/components/team-management/roles/roles.component';
import { RolePermissionsDetailComponent } from './features/settings/components/team-management/roles/role-permissions-detail/role-permissions-detail.component';
import { TeamsComponent } from './features/settings/components/team-management/teams/teams.component';
import { ForgetPasswordComponent } from './features/auth/authentication/forget-password/forget-password.component';
import { ResetPasswordComponent } from './features/auth/authentication/reset-password/reset-password.component';
import { MaintenancePageComponent } from './features/auth/authentication/maintenance-page/maintenance-page.component';
import { AccessDeniedComponent } from './features/auth/authentication/access-denied/access-denied.component';
import { MaintenanceGuard } from './core/guard/maintenance.guard';
import { ListComparatorsComponent } from './features/comparator/components/list-comparators/list-comparators.component';
import { UploadComparatorsProcessingComponent } from './features/comparator/components/upload-comparators-processing/upload-comparators-processing.component';
import { DetailsComparatorsComponent } from './features/comparator/components/details-comparators/details-comparators.component';
import { LanguageComponent } from './features/settings/components/language/language.component';
import { NotificationsComponent } from './features/settings/components/notifications/notifications.component';
import { NewAgentComponent } from './features/agents/components/new-agent/new-agent.component';
import { AgentDetailsComponent } from './features/agents/components/agent-details/agent-details.component';
import { NewCatalogComponent } from './features/catalogs/components/new-catalog/new-catalog.component';
import { NewCatalogAddProductsComponent } from './features/catalogs/components/new-catalog/new-catalog-add-products/new-catalog-add-products.component';
import { AgentsPageComponent } from './features/agents/components/agents-page/agents-page.component';
import { NewCommissionComponent } from './features/agents/components/commissions/new-commission/new-commission.component';
import { CommissionDetailsComponent } from './features/agents/components/commissions/commission-details/commission-details.component';
import { ListWarehousesComponent } from './features/warehouses/components/list-warehouses/list-warehouses.component';
import { PricebookPageComponent } from './features/pricebook/components/pricebook-page/pricebook-page.component';
import { UnipileCallbackComponent } from './features/smart-inbox/components/unipile/unipile-callback.components';
import { InboxPageComponent } from './features/smart-inbox/components/inbox-page/inbox-page.component';
import { ProfilePageComponent } from './features/settings/components/profile-page/profile-page.component';
import { SecurityPageComponent } from './features/settings/components/security-page/security-page.component';
import { TipsSettingsComponent } from './features/settings/components/tips-settings/tips-settings.component';
import { ListCustomFieldsComponent } from './features/settings/components/list-custom-fields/list-custom-fields.component';
import { SmartInboxSettingsComponent } from './features/settings/components/smart-inbox-settings/smart-inbox-settings.component';
import { WorkflowsPageComponent } from './features/workflows/components/workflows-page/workflows-page.component';
import { WorkflowsNewRulePageComponent } from './features/workflows/components/workflows-new-rule-page/workflows-new-rule-page.component';
import { OrdersSettingsComponent } from './features/settings/components/orders-settings/orders-settings.component';
import { KnowledgeBasePageComponent } from './features/knowledge-base/components/knowledge-base-page/knowledge-base-page.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    canActivate: [LoggedInAuthGuard],
    pathMatch: 'full'
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
    canActivate: [MaintenanceGuard]
  },
  {
    path: '403',
    component: AccessDeniedComponent,
  },
  {
    path: '',
    component: MainPageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'quotations',
        pathMatch: 'full'
      },
      {
        path: 'inventory',
        children: [
          {
            path: '',
            component: ListProduitsComponent,
            data: {
              module: 'inventory',
              rbac: {
                module: 'product',
              },
              breadcrumbs: [
                {
                  label: 'inventory',
                  url: '/inventory'
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              parentPath: null,
              icon: "assets/icones/inventory.svg"
            }
          },
          {
            path: 'add',
            component: AddProduitsComponent,
            data: {
              module: 'inventory',
              breadcrumbs: [
                {
                  label: 'inventory',
                  url: '/inventory'
                },
                {
                  label: 'add',
                  url: '/inventory/add'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/inventory.svg"
            }
          },
          {
            path: ':id',
            component: DetailsProductComponent,
            data: {
              module: 'inventory',
              breadcrumbs: [
                {
                  label: 'inventory',
                  url: '/inventory'
                },
                {
                  label: 'details',
                  url: '/inventory/details'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/inventory.svg"
            }
          }
        ]
      },
      {
        path: 'organize',
        component: OrganizeComponent,
        children: [
          {
            path: '',
            redirectTo: 'brands',
            pathMatch: 'full'
          },
          {
            path: 'categories',
            component: ListCategoriesComponent,
            data: {
              breadcrumbs: [
                {
                  label: 'organize',
                  url: null
                },
                {
                  label: 'categories',
                  url: null
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              icon: "assets/icones/categories.svg"
            }
          },
          {
            path: 'tags',
            component: ListTagsComponent,
            data: {
              breadcrumbs: [
                {
                  label: 'organize',
                  url: null
                },
                {
                  label: 'tags',
                  url: null
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              icon: "assets/icones/tags.svg"
            }
          },
          {
            path: 'brands',
            component: ListBrandsComponent,
            data: {
              breadcrumbs: [
                {
                  label: 'organize',
                  url: null
                },
                {
                  label: 'brands',
                  url: null
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              icon: "assets/icones/brands.svg"
            }
          },
        ]
      },
      {
        path: 'catalogs',
        children: [
          {
            path: '',
            component: ListCatalogsComponent,
            data: {
              module: 'catalogs',
              rbac: {
                module: 'catalog',
              },
              breadcrumbs: [
                {
                  label: 'catalogs',
                  url: '/catalogs'
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              parentPath: null,
              icon: "assets/icones/catalogs.svg"
            }
          },
          {
            path: 'add',
            component: AddCatalogsComponent,
            data: {
              module: 'catalogs',
              breadcrumbs: [
                {
                  label: 'catalogs',
                  url: '/catalogs'
                },
                {
                  label: 'add',
                  url: '/catalogs/details'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/catalogs.svg"
            }
          },
          {
            path: 'new-catalog',
            children: [
              {
                path: '',
                component: NewCatalogComponent,
              },
              {
                path: 'add-products',
                component: NewCatalogAddProductsComponent,
              },
            ],
          },
          {
            path: 'edit-catalog/:id',
            children: [
              {
                path: '',
                component: NewCatalogComponent,
              },
              
              {
                path: 'add-products',
                component: NewCatalogAddProductsComponent,
              },
            ]
          },
          {
            path: 'agents-catalog/edit-catalog/:id',
            children: [
              {
                path: '',
                component: NewCatalogComponent,
              },
              
              {
                path: 'add-products',
                component: NewCatalogAddProductsComponent,
              },
            ]
          },
          {
            path: ':id',
            component: DetailsCatalogComponent,
            data: {
              module: 'catalogs',
              breadcrumbs: [
                {
                  label: 'catalogs',
                  url: '/catalogs'
                },
                {
                  label: 'details',
                  url: '/catalogs/details'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/catalogs.svg"
            }
          },

        ]
      },
      {
        path: 'companies',
        children: [
          {
            path: '',
            component: ListCustomersComponent,
            data: {
              module: 'companies',
              breadcrumbs: [
                {
                  label: 'companies',
                  url: '/companies'
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              parentPath: null,
              icon: "assets/icones/companies.svg"
            }
          },
          {
            path: 'add',
            component: AddCustomersComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: { module: 'company', action: 'create' },
              module: 'companies',
              breadcrumbs: [
                {
                  label: 'companies',
                  url: '/companies'
                },
                {
                  label: 'add',
                  url: '/companies/add'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/companies.svg"
            }
          },
          {
            path: ':id',
            children: [
              {
                path: '',
                component: RecapLocationComponent,
                data: {
                  module: 'companies',
                  breadcrumbs: [
                    {
                      label: 'companies',
                      url: '/companies'
                    },
                    {
                      label: 'details',
                      url: '/companies/details'
                    }
                  ],
                  parentPath: '../',
                  icon: "assets/icones/companies.svg"
                }
              },
              {
                path: 'add-location/:company_id',
                component: AddCustomersComponent,
                canActivate: [PermissionGuard],
                data: {
                  rbac: { module: 'company', action: 'edit' },
                  module: 'companies',
                  breadcrumbs: [
                    {
                      label: 'companies',
                      url: '/companies'
                    },
                    {
                      label: 'details',
                      url: '/companies/{id}'
                    },
                    {
                      label: 'add-location',
                      url: '/companies/{id}/add-location/{company_id}'
                    }
                  ],
                  parentPath: '../../',
                  icon: "assets/icones/companies.svg"
                }
              }
            ]
          },
        ]
      },
      {
        path: 'companies-groups',
        children:[
          {
            path: '',
            component: ListCompaniesGroupsComponent,
            data: {
              module: 'companies-groups',
              breadcrumbs: [
                {
                  label: 'companies-groups',
                  url: '/companies-groups'
                },
                {
                  label: 'list',
                  url: null
                }
              ],
              parentPath: null,
              icon: "assets/icones/companies_groups.svg"
            }
          },
          {
            path: 'add',
            component: AddCompaniesGroupsComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: { module: 'company', action: 'create' },
              module: 'companies-groups',
              breadcrumbs: [
                {
                  label: 'companies-groups',
                  url: '/companies-groups'
                },
                {
                  label: 'add',
                  url: '/companies-groups/add'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/companies_groups.svg"
            }
          },
          {
            path: ':id',
            component: AddCompaniesGroupsComponent,
            data: {
              module: 'companies-groups',
              breadcrumbs: [
                {
                  label: 'companies-groups',
                  url: '/companies-groups'
                },
                {
                  label: 'details',
                  url: '/companies-groups/{id}'
                }
              ],
              parentPath: '../',
              icon: "assets/icones/companies_groups.svg"
            }
          },
        ]
      },
      {
        path: 'quotations',
        canActivate: [PermissionGuard],
        data: {
          rbac: {
            module: 'order',
          },
        },
        children: [
          {
            path: '',
            component: ListQuotationsComponent,
            data: {
              module: 'quotations',
              breadcrumbs: [
                {
                  label: 'quotations',
                  url: '/quotations'
                },
                {
                  label: 'list',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/quotations.svg"
            }
          },
          {
            path: 'add',
            component: AddQuotationComponent,
            data: {
              module: 'quotations',
              breadcrumbs: [
                {
                  label: 'quotations',
                  url: '/quotations'
                },
                {
                  label: 'add',
                  url: '/quotations/add'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/quotations.svg"
            }
          },
          {
            path: ':id',
            component: DetailsQuotesComponent,
            data: {
              module: 'quotations',
              breadcrumbs: [
                {
                  label: 'quotations',
                  url: '/quotations'
                },
                {
                  label: 'details',
                  url: '/quotations/{id}'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/quotations.svg"
            }
          },
        ]
      },
      {
        path: 'imports',
        children: [
          {
            path: '',
            component: ListImportsComponent,
            data: {
              module: 'imports',
              breadcrumbs: [
                {
                  label: 'imports',
                  url: '/imports'
                },
                {
                  label: 'list',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/imports.svg"
            }
          },
          {
            path: 'add',
            component: UploadProcessingComponent,
            data: {
              module: 'imports',
              breadcrumbs: [
                {
                  label: 'imports',
                  url: '/imports'
                },
                {
                  label: 'add',
                  url: '/imports/add'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/imports.svg"
            }
          },
          {
            path: ':id',
            component: DetailsImportsComponent,
            data: {
              module: 'imports',
              breadcrumbs: [
                {
                  label: 'imports',
                  url: '/imports'
                },
                {
                  label: 'details',
                  url: '/imports/{id}'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/imports.svg"
            }
          },
        ]
      },
      {
        path: 'orders',
        canActivate: [PermissionGuard],
        data: {
          rbac: {
            module: 'order',
          },
        },
        children: [
          {
            path: '',
            component: ListOrdersComponent,
            data: {
              module: 'orders',
              breadcrumbs: [
                {
                  label: 'orders',
                  url: '/orders'
                },
                {
                  label: 'list',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/orders.svg"
            }
          },
          {
            path: ':id',
            component: DetailsQuotesComponent,
            data: {
              module: 'orders',
              breadcrumbs: [
                {
                  label: 'orders',
                  url: '/orders'
                },
                {
                  label: 'details',
                  url: '/orders/{id}'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/orders.svg"
            }
          },
        ]
      },
      {
        path: 'segments',
        component: ListSegmentsComponent,
        data: {
          module: 'segments',
          breadcrumbs: [
            {
              label: 'segments',
              url: '/segments'
            },
            {
              label: 'list',
              url: null
            },
          ],
          parentPath: null,
          icon: "assets/icones/segments.svg"
        }
      },
      {
        path: 'comparators',
        children: [
          {
            path: '',
            component: ListComparatorsComponent,
            data: {
              module: 'comparators',
              breadcrumbs: [
                {
                  label: 'comparators',
                  url: '/comparators'
                },
                {
                  label: 'list',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/comparators.svg"
            }
          },
          {
            path: 'add',
            component: UploadComparatorsProcessingComponent,
            data: {
              module: 'comparators',
              breadcrumbs: [
                {
                  label: 'comparators',
                  url: '/comparators'
                },
                {
                  label: 'add',
                  url: '/comparators/add'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/comparators.svg"
            }
          },
          {
            path: ':id',
            component: DetailsComparatorsComponent,
            data: {
              module: 'comparators',
              breadcrumbs: [
                {
                  label: 'comparators',
                  url: '/comparators'
                },
                {
                  label: 'details',
                  url: '/comparators/{id}'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/comparators.svg"
            }
          },
        ]
      },
      // {
      //   path: 'suppliers',
      //   component: ListSuppliersComponent
      // },
      {
        path: 'settings',
        component: MainSettingsComponent,
        children: [
          {
            path: '',
            redirectTo: 'profile',
            pathMatch: 'full'
          },
          {
            path: 'profile',
            component: ProfilePageComponent,
            data: {
              module: 'profile',
              breadcrumbs: [
                {
                  label: 'profile',
                  url: '/settings/profile'
                },
              ],
              parentPath: null,
              icon: "assets/icones/user.svg"
            }
          },
          {
            // No PermissionGuard, like `profile`: gating the only page that
            // satisfies the MFA policy would lock users out of it.
            path: 'security',
            component: SecurityPageComponent,
            data: {
              module: 'security',
              breadcrumbs: [
                {
                  label: 'security',
                  url: '/settings/security'
                },
              ],
              parentPath: null,
              icon: "assets/icones/user.svg"
            }
          },
          {
            // User-level, so no PermissionGuard: every signed-in user owns their
            // own tips (WB-7535).
            path: 'tips',
            component: TipsSettingsComponent,
            data: {
              module: 'profile',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'tips',
                  url: '/settings/tips'
                },
              ],
              parentPath: null,
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'users',
            component: UsersComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_team',
              },
              module: 'settings',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'users',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'roles',
            component: RolesComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_team',
              },
              module: 'roles-permissions',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'roles-permissions',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'teams',
            component: TeamsComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_team',
              },
              module: 'teams',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'teams',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'roles-permissions',
            redirectTo: 'roles',
            pathMatch: 'full',
          },
          {
            path: 'roles/:id',
            component: RolePermissionsDetailComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_team',
              },
              module: 'roles-permissions',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'roles-permissions',
                  url: '/settings/roles'
                },
                {
                  label: 'details',
                  url: null
                },
              ],
              parentPath: '../',
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'language',
            component: LanguageComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_company',
              },
              module: 'language',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'language',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'notifications',
            component: NotificationsComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_company',
              },
              module: 'notifications',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'notifications',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/settings.svg"
            }
          },
          {
            path: 'warehouses',
            component: ListWarehousesComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_company',
              },
              module: 'warehouses',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'warehouses',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/inventory.svg"
            }
          },
          {
            path: 'custom-fields',
            component: ListCustomFieldsComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_company',
              },
              module: 'custom-fields',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'custom-fields',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/chevrons.svg"
            }
          },
          {
            path: 'smart-inbox',
            component: SmartInboxSettingsComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'smart_inbox',
              },
              module: 'smart-inbox',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'settings.smart_inbox',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/inbox.svg"
            }
          },
          {
            path: 'orders',
            component: OrdersSettingsComponent,
            canActivate: [PermissionGuard],
            data: {
              rbac: {
                module: 'settings_company',
              },
              module: 'orders',
              breadcrumbs: [
                {
                  label: 'settings',
                  url: '/settings'
                },
                {
                  label: 'settings.orders',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/orders.svg"
            }
          }
        ]
      },
      {
        path: 'agents',
        children: [
          {
            path: '',
            component: AgentsPageComponent,
            data: {
              module: 'agents',
              breadcrumbs: [
                {
                  label: 'agents',
                  url: '/agents'
                },
                {
                  label: 'list',
                  url: null
                },
              ],
              parentPath: null,
              icon: "assets/icones/briefcase.svg"
            }
          },
          {
            path: 'add',
            component: NewAgentComponent,
          },
          {
            path: 'commissions',
            children: [
              {
                path: '',
                component: AgentsPageComponent
              },
              {
                path: 'add',
                component: NewCommissionComponent,
              },
              {
                path: ':id',
                component: CommissionDetailsComponent,
                data: {
                  module: 'agents',
                  breadcrumbs: [
                    {
                      label: 'commissions',
                      url: '/agents/commissions'
                    },
                    {
                      label: 'details',
                      url: '/agents/commissions/{id}'
                    },
                  ],
                  parentPath: '../',
                  icon: "assets/icones/briefcase.svg"
                }
              },
            ]
          },
          {
            path: 'new-catalog',
            children: [
              {
                path: '',
                component: NewCatalogComponent,
              },
              {
                path: 'add-products',
                component: NewCatalogAddProductsComponent,
              },
            ]
          },
          {
            path: ':id',
            component: AgentDetailsComponent,
            data: {
              module: 'agents',
              breadcrumbs: [
                {
                  label: 'agents',
                  url: '/agents'
                },
                {
                  label: 'details',
                  url: '/agents/{id}'
                },
              ],
              parentPath: '../',
              icon: "assets/icones/briefcase.svg"
            }
          },
          {
            path: 'edit-catalog/:id',
            children: [
              {
                path: '',
                component: NewCatalogComponent,
              },
              
              {
                path: 'add-products',
                component: NewCatalogAddProductsComponent,
              },
            ]
          },
        ]
      },
      {
        // Pricebook/loyalty feature hidden front-end-wide due to business decision (WB-6694).
        // Route kept but redirected so direct /pricebook URLs no longer open the page.
        // Restore the original component/guard config below to re-enable.
        // component: PricebookPageComponent,
        // canActivate: [FeatureFlagGuard],
        // data: { module_required: 'wolsal_loyalty' },
        path: 'pricebook',
        redirectTo: 'quotations',
        pathMatch: 'full',
      },
      {
        path: 'smart-inbox',
        canActivate: [PermissionGuard],
        data: {
          rbac: {
            module: 'smart_inbox',
          },
        },
        children: [
          {
            path: '',
            component: InboxPageComponent,
          },
        ]
      },
      {
        path: 'workflows',
        canActivate: [PermissionGuard],
        data: { rbac: { module: 'workflow' } },
        children: [
          { path: '', component: WorkflowsPageComponent },
          { path: 'new-rule', component: WorkflowsNewRulePageComponent },
          { path: 'edit-rule/:id', component: WorkflowsNewRulePageComponent },
        ],
      },
      {
        path: 'knowledge-base',
        component: KnowledgeBasePageComponent,
        canActivate: [PermissionGuard],
        data: {
          rbac: {
            module: 'knowledge_base',
          },
        },
      }
    ]
  },
  {
    path: 'unipile-callback',
    component: UnipileCallbackComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
